export const Details = {
  SerialNumber: "serialNumber" as const,
  CustomerName: "customerName" as const,
  CustomerOrgNr: "customerOrgNr" as const,
  ReferencePerson: "referencePerson" as const,
  ContactPerson: "contactPerson" as const,
  Owner: "owner" as const,
  AmountIncludingVat: "amountIncludingVat" as const,
  AmountExcludingVat: "amountExcludingVat" as const,
  LeftToPay: "leftToPay" as const,
  Vat: "vat" as const,
  Currency: "currency" as const,
  InvoiceDate: "invoiceDate" as const,
  DueDate: "dueDate" as const,
  DeliveryDate: "deliveryDate" as const,
  PaymentMethod: "paymentMethod" as const,
  PaymentDate: "paymentDate" as const,
  Bg: "bg" as const,
  Ocr: "ocr" as const,
  PaymentTerms: "paymentTerms" as const,
  PaymentStatus: "paymentStatus" as const,
  HasRowLevelDimensions: "hasRowLevelDimensions" as const,
  Dimensions: "dimensions" as const,
  PeriodisationSummary: "periodisationSummary" as const,
  RecurringDescription: "recurringDescription" as const,
  RecurringInvoiceStartDate: "recurringInvoiceStartDate" as const,
  RecurringInvoiceFrequencyName: "recurringInvoiceFrequencyName" as const,
  RecurringInvoiceLastInvoice: "recurringInvoiceLastInvoice" as const,
  RecurringDeliveryAfterDays: "recurringDeliveryAfterDays" as const,
  IsAutomaticRemindersEnabled: "isAutomaticRemindersEnabled" as const,
  AutomaticReminderPeriod: "automaticReminderPeriod" as const,
  AutomaticReminderDelay: "automaticReminderDelay" as const,
  AutomaticReminderAmountLimit: "automaticReminderAmountLimit" as const,
  AutomaticReminderCountLimit: "automaticReminderCountLimit" as const,
  AutomaticReminderSendMethod: "automaticReminderSendMethod" as const,
  AutomaticReminderMailToAddresses: "automaticReminderMailToAddresses" as const,
}

export const EditDueDate = {
  DueDate: "dueDate" as const,
}

export const ReportAsPaid = {
  PaymentDate: "paymentDate" as const,
}

export const PaymentReminder = {
  Title: "title" as const,
  Message: "message" as const,
  ReminderCost: "reminderCost" as const,
  ReminderCostHidden: "reminderCostHidden" as const,
  ReminderDate: "reminderDate" as const,
}

export const SendMail = {
  EmailFromType: "emailFromType" as const,
  EmailFrom: "emailFrom" as const,
  EmailTo: "emailTo" as const,
  EmailSubject: "emailSubject" as const,
  EmailMessage: "emailMessage" as const,
}

export const SendMailOptions = {
  MailFromList: "mailFromList" as const,
  MailToList: "mailToList" as const,
  EmailFromType: "emailFromType" as const,
  EmailFrom: "emailFrom" as const,
  MailSubject: "mailSubject" as const,
  MailMessage: "mailMessage" as const,
  DefaultEmailTo: "defaultEmailTo" as const,
}

export const DefaultEmailTo = {
  Customer: "customer" as const,
  ReferencePerson: "referencePerson" as const,
}

export const DefaultEmailToSettings = {
  EmailToType: "emailToType" as const,
  CustomEmail: "customEmail" as const,
}

export const Create = {
  Id: "id" as const,
  SerialNumber: "serialNumber" as const,
  QuotationSerialNumber: "quotationSerialNumber" as const,
  OwnerId: "ownerId" as const,
  LoadingCustomer: "loadingCustomer" as const,
  Customer: "customer" as const,
  CustomerRating: "customerRating" as const,
  ReferencePerson: "referencePerson" as const,
  Total: "total" as const,
  Tax: "tax" as const,
  OtherSettings: "otherSettings" as const,
  RutRot: "rutRot" as const,
  RecurringSettings: "recurringSettings" as const,
  PreviewSendMail: "previewSendMail" as const,
  MailOptions: "mailOptions" as const,
  DefaultSendType: "defaultSendType" as const,
  DefaultEmailToSettings: "defaultEmailToSettings" as const,
  ForwardedCosts: "forwardedCosts" as const,
}

export const ForwardedCosts = {
  CustomerId: "customerId" as const,
  Links: "links" as const,
  AttachDocuments: "attachDocuments" as const,
  Customer: "customer" as const,
  RemovedCosts: "removedCosts" as const,
}

export const ForwardedCostLink = {
  CostId: "costId" as const,
  RowUniqueId: "rowUniqueId" as const,
  NetAmountSek: "netAmountSek" as const,
  ExchangeRate: "exchangeRate" as const,
  Currency: "currency" as const,
  MarkupPercentage: "markupPercentage" as const,
  Again: "again" as const,
  AttachedFileNames: "attachedFileNames" as const,
  MissingDocument: "missingDocument" as const,
  MissingReason: "missingReason" as const,
}

export const ForwardedCostsDialog = {
  Rows: "rows" as const,
  AttachDocuments: "attachDocuments" as const,
}

export const ForwardedCostsDialogRow = {
  CostId: "costId" as const,
  Selected: "selected" as const,
  IsSelectable: "isSelectable" as const,
  SourceDocument: "sourceDocument" as const,
  Date: "date" as const,
  Text: "text" as const,
  Amount: "amount" as const,
  MarkupPercentage: "markupPercentage" as const,
}

export const CreateBase = {
  Products: "products" as const,
  Currency: "currency" as const,
  IsDimensionsAdvancedConfiguration: "isDimensionsAdvancedConfiguration" as const,
  IsPeriodisationAdvancedConfiguration: "isPeriodisationAdvancedConfiguration" as const,
  IsPeriodisationByDate: "isPeriodisationByDate" as const,
  IsEUCustomer: "isEUCustomer" as const,
  Above: "above" as const,
  IsDomesticCustomer: "isDomesticCustomer" as const,
  FromRecurring: "fromRecurring" as const,
}

export const OtherSettings = {
  InvoiceDate: "invoiceDate" as const,
  DeliveryDate: "deliveryDate" as const,
  PaymentTerms: "paymentTerms" as const,
  DueDate: "dueDate" as const,
  Notes: "notes" as const,
  Attachments: "attachments" as const,
  InvoiceLayout: "invoiceLayout" as const,
  LanguageKey: "languageKey" as const,
  ShowCurrencyCode: "showCurrencyCode" as const,
  ShowReferenceInAddress: "showReferenceInAddress" as const,
  ShowCustomerDeliveryAddress: "showCustomerDeliveryAddress" as const,
  SellerName: "sellerName" as const,
  PaymentMethodId: "paymentMethodId" as const,
  ReminderCost: "reminderCost" as const,
  PenaltyInterestType: "penaltyInterestType" as const,
  PenaltyInterestPercentage: "penaltyInterestPercentage" as const,
  IsAutomaticRemindersEnabled: "isAutomaticRemindersEnabled" as const,
  AutomaticReminderDelay: "automaticReminderDelay" as const,
  AutomaticReminderAmountLimit: "automaticReminderAmountLimit" as const,
  AutomaticReminderPeriod: "automaticReminderPeriod" as const,
  AutomaticReminderCountLimit: "automaticReminderCountLimit" as const,
  AutomaticReminderSendType: "automaticReminderSendType" as const,
  AutomaticReminderSendMail: "automaticReminderSendMail" as const,
  AutomaticReminderNotes: "automaticReminderNotes" as const,
  DefaultReminderEmailToSettings: "defaultReminderEmailToSettings" as const,
}

export const RutRot = {
  HouseWorkType: "houseWorkType" as const,
  RutRotArticles: "rutRotArticles" as const,
  RutRotPersonNumber: "rutRotPersonNumber" as const,
  RotPropertyType: "rotPropertyType" as const,
  PropertyDesignation: "propertyDesignation" as const,
  TenantsOrgNumber: "tenantsOrgNumber" as const,
  ApartmentNumber: "apartmentNumber" as const,
  HouseWorkOtherCosts: "houseWorkOtherCosts" as const,
  RutRotSummary: "rutRotSummary" as const,
}

export const Product = {
  Id: "id" as const,
  Guid: "guid" as const,
  UniqueId: "uniqueId" as const,
  Article: "article" as const,
  Price: "price" as const,
  Quantity: "quantity" as const,
  Unit: "unit" as const,
  Only: "only" as const,
  Account: "account" as const,
  Rate: "rate" as const,
  Above: "above" as const,
  ArticleAccount: "articleAccount" as const,
  ArticleVat: "articleVat" as const,
  ArticleIsAgentSale: "articleIsAgentSale" as const,
  Tax: "tax" as const,
  TaxText: "taxText" as const,
  TotalAmountExTax: "totalAmountExTax" as const,
  Text: "text" as const,
  Periodisation: "periodisation" as const,
  RecurringPeriodisation: "recurringPeriodisation" as const,
  EUVatCategoryId: "eUVatCategoryId" as const,
  Dimensions: "dimensions" as const,
  IsEUCustomer: "isEUCustomer" as const,
}

export const RutRotArticleItem = {
  Id: "id" as const,
  Name: "name" as const,
  NoOfHours: "noOfHours" as const,
  TypeOfWorkId: "typeOfWorkId" as const,
  MaterialCost: "materialCost" as const,
  MaterialCostSuggestionsId: "materialCostSuggestionsId" as const,
}

export const RecurringSettings = {
  RecurringDescription: "recurringDescription" as const,
  RecurringOwner: "recurringOwner" as const,
  RecurringInvoiceSendType: "recurringInvoiceSendType" as const,
  RecurringInvoiceAutomaticSendType: "recurringInvoiceAutomaticSendType" as const,
  RecurringInvoiceStartDate: "recurringInvoiceStartDate" as const,
  RecurringInvoiceFrequency: "recurringInvoiceFrequency" as const,
  RecurringRepeatUntilNotice: "recurringRepeatUntilNotice" as const,
  RecurringInvoiceEndDate: "recurringInvoiceEndDate" as const,
  RecurringDeliveryAfterDays: "recurringDeliveryAfterDays" as const,
  RecurringSendMail: "recurringSendMail" as const,
}

export const RecurringPeriodisation = {
  IsEnabled: "isEnabled" as const,
  From: "from" as const,
  Duration: "duration" as const,
}

export const InvoicePeriodisation = {
  IsEnabled: "isEnabled" as const,
  Range: "range" as const,
  Mode: "mode" as const,
}

export const Todo = {
  UseToday: "useToday" as const,
  Notes: "notes" as const,
  Attachments: "attachments" as const,
  SendType: "sendType" as const,
  SendMail: "sendMail" as const,
  LoadingMailOptions: "loadingMailOptions" as const,
  LoadingSendType: "loadingSendType" as const,
}

export const ProductPeriodisation = {
  Text: "text" as const,
  Periodisation: "periodisation" as const,
  Mode: "mode" as const,
}

export const Filter = {
  InvoiceDate: "invoiceDate" as const,
  DueDate: "dueDate" as const,
  LedgerDate: "ledgerDate" as const,
  Owners: "owners" as const,
  Customers: "customers" as const,
  SerialNumber: "serialNumber" as const,
  InvoiceStatuses: "invoiceStatuses" as const,
  PaymentStatuses: "paymentStatuses" as const,
  RotAndRut: "rotAndRut" as const,
  Articles: "articles" as const,
  CreditStatus: "creditStatus" as const,
  ShowCreditSameMonth: "showCreditSameMonth" as const,
  InvoicedAmount: "invoicedAmount" as const,
  UnpaidAmount: "unpaidAmount" as const,
  RecurringInvoiceId: "recurringInvoiceId" as const,
  AgentInvoicesId: "agentInvoicesId" as const,
  Dimensions: "dimensions" as const,
  Sources: "sources" as const,
}

export const RecurringInvoiceFilter = {
  OwnerName: "ownerName" as const,
  OwnerId: "ownerId" as const,
  CustomerName: "customerName" as const,
  Frequency: "frequency" as const,
  CustomerId: "customerId" as const,
  StartDate: "startDate" as const,
  EndDate: "endDate" as const,
  SendType: "sendType" as const,
  NumOfSentInvoices: "numOfSentInvoices" as const,
  Status: "status" as const,
  Amount: "amount" as const,
  Income: "income" as const,
}

export const Preview = {
  CustomerId: "customerId" as const,
  ReferencePersonId: "referencePersonId" as const,
  ReferencePersonName: "referencePersonName" as const,
  SendType: "sendType" as const,
  SendMail: "sendMail" as const,
  Notes: "notes" as const,
  Attachments: "attachments" as const,
  IsInvoiceDraft: "isInvoiceDraft" as const,
  ReminderCost: "reminderCost" as const,
  ReminderCostHidden: "reminderCostHidden" as const,
  ReminderDate: "reminderDate" as const,
  MailOptions: "mailOptions" as const,
  DefaultEmailToSettings: "defaultEmailToSettings" as const,
  LoadingMailOptions: "loadingMailOptions" as const,
  LoadingSendType: "loadingSendType" as const,
}

export const QuotationPreview = {
  SendType: "sendType" as const,
  SendMail: "sendMail" as const,
  Notes: "notes" as const,
  Attachments: "attachments" as const,
  Loading: "loading" as const,
}

export const SendToDebtCollection = {
  Note: "note" as const,
}

export const SelfInvoice = {
  Id: "id" as const,
  RelatedInvoiceId: "relatedInvoiceId" as const,
  Customer: "customer" as const,
  OrganizationNumber: "organizationNumber" as const,
  InvoiceDate: "invoiceDate" as const,
  OCRNumber: "oCRNumber" as const,
  OwnerId: "ownerId" as const,
}

export const SelfInvoiceTodo = {
  Dimensions: "dimensions" as const,
}

export const ActivateInvoices = {
  HasSentInvoiceBefore: "hasSentInvoiceBefore" as const,
  LastInvoiceNumber: "lastInvoiceNumber" as const,
  PreferedStartInvoiceNumber: "preferedStartInvoiceNumber" as const,
  HasEUCustomers: "hasEUCustomers" as const,
  HasRegisteredForFTax: "hasRegisteredForFTax" as const,
}

export const DefaultInvoiceDeliverySettings = {
  InvoiceSendType: "invoiceSendType" as const,
  InvoiceTitleTemplate: "invoiceTitleTemplate" as const,
  InvoiceMessageTemplate: "invoiceMessageTemplate" as const,
  ReminderCost: "reminderCost" as const,
  IsAutomaticRemindersEnabled: "isAutomaticRemindersEnabled" as const,
  AutomaticReminderAmountLimit: "automaticReminderAmountLimit" as const,
  AutomaticReminderDelay: "automaticReminderDelay" as const,
  AutomaticReminderPeriod: "automaticReminderPeriod" as const,
  AutomaticReminderCountLimit: "automaticReminderCountLimit" as const,
  AutomaticReminderSendType: "automaticReminderSendType" as const,
  InvoiceReminderNotesTemplate: "invoiceReminderNotesTemplate" as const,
  InvoiceReminderTitleTemplate: "invoiceReminderTitleTemplate" as const,
  InvoiceReminderMessageTemplate: "invoiceReminderMessageTemplate" as const,
  InvoiceReminderFileNameTemplate: "invoiceReminderFileNameTemplate" as const,
  InvoiceNotesTemplate: "invoiceNotesTemplate" as const,
}

